import * as Constants from "../utils/constants";
import * as ApiUtils from "./api-utils";
import { Journey, StationDefinition } from "./api-data-model";

export type GetJourneysQueryData = {
  from: StationDefinition;
  to: StationDefinition;
  from_datetime: Date;
  count: number;
  direct: boolean;
};

export type GetJourneysResult = {
  journeys: Journey[];
  query: GetJourneysQueryData;
  delay_threshold: string;
};

export type JourneyIncident = {
  delay_minute: number;
  end: string;
  start: string;
  struct_responsable: string;
  type_defaillance: string;
  type_incident: string;
  type_ressource: string;
};

export type JourneyHistory = {
  start_terminus: string;
  stop_terminus: string;
  incidents: JourneyIncident[];
  stops: {
    base_datetime: Date;
    real_datetime: Date;
    station: string;
    suppr: boolean;
  }[];
};

export type GetJourneyDetailsResult = {
  history: JourneyHistory[];
  journey: Journey;
  query: GetJourneysQueryData;
};

function parseJourney(value: any): Journey {
  value.arrival_datetime = new Date(value.arrival_datetime);
  value.departure_datetime = new Date(value.departure_datetime);
  value.sections.forEach(function (section: any) {
    section.arrival_datetime = new Date(section.arrival_datetime);
    section.departure_datetime = new Date(section.departure_datetime);
  });
  return value;
}

export async function getJourneys(
  fromId: string,
  toId: string,
  date: Date,
  count: number = 20,
  direct: boolean = true
): Promise<GetJourneysResult> {
  let url = ApiUtils.AppendParams(Constants.API_EP_GET_JOURNEYS, {
    from: fromId,
    to: toId,
    from_datetime: ApiUtils.dateToAPIString(date),
    count: count,
    direct: direct,
  });
  let response = await fetch(url);
  let journeysResult = await response.json();
  // parse dates
  journeysResult.journeys.forEach(parseJourney);
  journeysResult.query.from_datetime = new Date(
    journeysResult.query.from_datetime
  );
  return journeysResult;
}

export async function getJourneyDetails(
  journeyId: string,
  fromId: string,
  toId: string,
  date: Date,
  count: number = 20,
  minDelay: number = 5
): Promise<GetJourneyDetailsResult> {
  let url = ApiUtils.AppendParams(Constants.API_EP_GET_JOURNEYS + journeyId, {
    from: fromId,
    to: toId,
    from_datetime: ApiUtils.dateToAPIString(date),
    count: count,
    min_delay: minDelay,
  });
  let response = await fetch(url);
  let journeyDetailsResult = await response.json();
  journeyDetailsResult.journey = parseJourney(journeyDetailsResult.journey);
  journeyDetailsResult.history.forEach(function (history: any) {
    history.stops.forEach(function (stop: any) {
      stop.base_datetime = new Date(stop.base_datetime);
      if (stop.real_datetime) {
        stop.real_datetime = new Date(stop.real_datetime);
      }
    });
  });
  journeyDetailsResult.query.from_datetime = new Date(
    journeyDetailsResult.query.from_datetime
  );
  return journeyDetailsResult;
}
